import {
  getAboveNode,
  isElement,
  PlateEditor,
  splitNodes,
  unwrapNodes,
  UnwrapNodesOptions,
  Value,
  withoutNormalizing,
} from '@udecode/plate-common';

import { ELEMENT_ANCHOR_LINK } from '../../../plateTypes';

/** Unwrap link node. */
export const unwrapAnchorLink = <V extends Value>(
  editor: PlateEditor<V>,
  options?: UnwrapNodesOptions & {
    split?: boolean;
  },
): boolean | void => {
  return withoutNormalizing(editor, () => {
    if (options?.split) {
      const linkAboveAnchor = getAboveNode(editor, {
        at: editor.selection?.anchor,
        match: { type: ELEMENT_ANCHOR_LINK },
      });

      // anchor in link
      if (linkAboveAnchor) {
        splitNodes(editor, {
          at: editor.selection?.anchor,
          match: (n) => isElement(n) && n.type === ELEMENT_ANCHOR_LINK,
        });
        unwrapAnchorLink(editor, {
          at: editor.selection?.anchor,
        });
        return true;
      }
      const linkAboveFocus = getAboveNode(editor, {
        at: editor.selection?.focus,
        match: { type: ELEMENT_ANCHOR_LINK },
      });

      // focus in link
      if (linkAboveFocus) {
        splitNodes(editor, {
          at: editor.selection?.focus,
          match: (n) => isElement(n) && n.type === ELEMENT_ANCHOR_LINK,
        });
        unwrapAnchorLink(editor, {
          at: editor.selection?.focus,
        });
        return true;
      }
    }

    unwrapNodes(editor, {
      match: { type: ELEMENT_ANCHOR_LINK },
      ...options,
    });
  });
};
